export default "__VITE_ASSET__Drs8Yh18__"